import { useEffect, useState } from "react";

export const CAMERA_PERMISSION_STATUS = {
    CHECKING: "checking",
    GRANTED: "granted",
    DENIED: "denied",
};

/**
 * Requests camera access up front, before any scan step is shown. If the
 * user denies/dismisses the browser prompt, or no camera is available at
 * all, callers must block every scan step behind this and show an error
 * instead of letting the flow continue.
 */
export const useCameraPermission = () => {
    const [status, setStatus] = useState(CAMERA_PERMISSION_STATUS.CHECKING);

    useEffect(() => {
        let cancelled = false;

        const requestCamera = async () => {
            if (!navigator?.mediaDevices?.getUserMedia) {
                if (!cancelled) setStatus(CAMERA_PERMISSION_STATUS.DENIED);
                return;
            }

            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach((track) => track.stop());
                if (!cancelled) setStatus(CAMERA_PERMISSION_STATUS.GRANTED);
            } catch (error) {
                if (!cancelled) setStatus(CAMERA_PERMISSION_STATUS.DENIED);
            }
        };

        requestCamera();

        return () => {
            cancelled = true;
        };
    }, []);

    return status;
};
